import * as React from 'react';
import {Link} from 'react-router-dom';

import {AssetGroup} from '@deviceinsight/ng-ui-api-client';

type Props = {
	assetGroup: AssetGroup;
	ancestors: Array<AssetGroup>;
};

const orderedHierarchy = (ancestors: Array<AssetGroup>, assetGroup: AssetGroup) => {
	const ancestorsById = ancestors.reduce(
		(acc, ancestor) => ({...acc, [ancestor.id]: ancestor}),
		{} as Record<number, AssetGroup>
	);
	let currentAssetGroup = assetGroup;
	const result = [];

	while (currentAssetGroup && currentAssetGroup.parentId) {
		result.unshift(currentAssetGroup);
		currentAssetGroup = ancestorsById[currentAssetGroup.parentId || 0];
	}

	if (currentAssetGroup) {
		result.unshift(currentAssetGroup);
	}

	return result;
};

export default class AssetGroupHierarchy extends React.Component<Props> {
	render() {
		const {assetGroup, ancestors} = this.props;
		return (
			<span className="di breadcrumb">
				{orderedHierarchy(ancestors, assetGroup).map((ancestor) => (
					<AssetGroupHierarchySection
						assetGroup={ancestor}
						key={ancestor.id}
						active={ancestor === assetGroup}
					/>
				))}
			</span>
		);
	}
}
type SectionProps = {
	assetGroup: AssetGroup;
	active?: boolean;
};

class AssetGroupHierarchySection extends React.Component<SectionProps> {
	render() {
		const {assetGroup, active} = this.props;
		const name = assetGroup.displayName || assetGroup.name;
		return (
			<span key={assetGroup.id} className={`section ${active ? 'active' : ''}`}>
				{!active ? <Link to={`/assetgroups/${assetGroup.id}`}>{name}</Link> : name}
				{!active && <span className="divider" />}
			</span>
		);
	}
}
